import ContentLarge from "components/elements/ContentLarge"
import ContentNormal from "components/elements/ContentNormal"
import Headline1 from "components/elements/Headline1"
import { AppContext } from "contexts/AppContext"
import React, { useContext } from "react"
import "./Help.css"
import Headline5 from "components/elements/Headline5"
import ContentExtraSmall from "components/elements/ContentExtraSmall"
import Headline6 from "components/elements/Headline6"
import SectionWrapper from "components/layouts/SectionWrapper"

const Contact = (props) => {
    const { styleGuide, brandData} = useContext(AppContext);
    const brandSlug = brandData && brandData.brandSlug;
    const contactEmail = brandData && brandData.contactEmail;
    const contactPhone = brandData && brandData.contactPhone;
    const textColor = brandData.features.personalShopperTextColorBlack ? styleGuide.color18 : styleGuide.color1;
    const openingHoursMonThurs = brandData.features && brandData.features.openingHoursMonThurs || null
    const openingHoursFri = brandData.features && brandData.features.openingHoursFri || null

    return (
        <SectionWrapper>
            <div id="contact-section" ref={props.ref} style={{ display: "flex", flexDirection: "column", gap: "1rem", paddingTop: 40}} >

                <Headline1 translationKey="_CONTACT_US_" className="faq-contact-us-title">Kontakt os</Headline1>

                <ContentNormal translationKey="_FOR_QUESTIONS_SEND_MAIL_" className="faq-contact-content">Har du spørgsmål til din ordre eller produkter, også dem du ikke lige finder i shoppen, så send en mail til os.</ContentNormal>

                <div id="faq-contact-flex-box">
                    <div className="faq-Contact-box" style={{ background: styleGuide.color2 }}>
                        <Headline5 translationKey="_CONTACT_INFORMATION_">Kontaktinformation</Headline5>
                        <div style={{ display: "flex", flexDirection: "column", wordWrap: "anywhere" }}>
                            <ContentExtraSmall>Mail</ContentExtraSmall>

                            <Headline6>{contactEmail ? contactEmail : brandSlug ? `support+${brandSlug}@upgrader.club` : `support@upgrader.club`}</Headline6>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <ContentExtraSmall translationKey="_TELEPHONE_">Telefon</ContentExtraSmall>

                            <Headline6>{contactPhone ? contactPhone : '+45 31 15 84 11'}</Headline6>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <ContentExtraSmall translationKey="_OPENING_HOURS_CAPTION_">Åbningstider</ContentExtraSmall>
                            <div style={{ display: "flex", flexDirection: "row", marginTop: 8 }}>
                                <ContentExtraSmall translationKey="_OPENING_HOURS_LABEL_MONDAY_TO_THURSDAY_" style={{marginRight: 8}}>Mandag til torsdag:</ContentExtraSmall>
                                <Headline6 style={{textAlign: 'end'}}>{openingHoursMonThurs ? openingHoursMonThurs : '8.30 - 16.00'}</Headline6>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", marginTop: 8, alignSelf: 'end' }}>
                                <ContentExtraSmall translationKey="_OPENING_HOURS_LABEL_FRIDAY_" style={{marginRight: 8}}>Fredag:</ContentExtraSmall>
                                <Headline6>{openingHoursFri ? openingHoursFri : '8.30 - 14.30'}</Headline6>
                            </div>
                        </div>
                    </div>
                    {brandData && brandData.features && brandData.features.personalshopper && <div className="faq-Personal-shopper-box" style={{ background: styleGuide.color14 }}>
                        <Headline5 translationKey="_FOR_PERSONAL_SHOPPER_SERVICE_" style={{ color: textColor }}>Hvis du ønsker at benytte dig af vores personal shopper service, skal du oplyse følgende:</Headline5>
                        <ul className="faq-contact-list" style={{ color: textColor }}>
                            <li translationKey="_INSERT_A_LINK_" >Indsæt link til den ønskede vare</li>
                            <li translationKey="_SPECIFY_VARIANT_SIZE_COLOR_" >Angiv variant, størrelse, farve mm.</li>
                        </ul>
                        <ContentNormal translationKey="_INVESTIGATE_ITEM_DELIVERY_" style={{ color: textColor }}>Så vil vi undersøge, om vi kan levere den ønskede vare, samt hvad den koster i point.</ContentNormal>
                    </div>}
                </div>
            </div>
        </SectionWrapper>
    )
}

export default Contact